/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraphDataModel } from '../../models/graph-data-model';
import { GraphGrouping } from '../../models/graph-grouping';

export interface GetMixedGraph$Params {
  patientID?: number;
  targetIDs?: Array<number>;
  behaviorIDs?: Array<number>;
  startTime?: string;
  endTime?: string;
  graphGrouping?: GraphGrouping;
  staffID?: number;
  includeTrendLine?: boolean;
  segmentTrendLineByPhase?: boolean;
  mergeSeries?: boolean;
}

export function GetMixedGraph(http: HttpClient, rootUrl: string, params?: GetMixedGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
  const rb = new RequestBuilder(rootUrl, GetMixedGraph.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('targetIDs', params.targetIDs, {});
    rb.query('behaviorIDs', params.behaviorIDs, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
    rb.query('graphGrouping', params.graphGrouping, {});
    rb.query('staffID', params.staffID, {});
    rb.query('includeTrendLine', params.includeTrendLine, {});
    rb.query('segmentTrendLineByPhase', params.segmentTrendLineByPhase, {});
    rb.query('mergeSeries', params.mergeSeries, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GraphDataModel>;
    })
  );
}

GetMixedGraph.PATH = '/api/Graph/GetMixedGraph';
